import { render, staticRenderFns } from "./ActivatePage.vue?vue&type=template&id=24779400"
import script from "./ActivatePage.vue?vue&type=script&lang=ts"
export * from "./ActivatePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports